import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './pages/LoginForm';
import Dashboard from './pages/Dashboard';
import ThePorchReservations from './components/ThePorchReservations';
import Food from './components/MenusPage';

// New Components for Table Scanner System
import QRGenerator from './components/tables/QRGenerator';
import LiveOrders from './components/tables/LiveOrders';
import Order from './components/tables/Order'; // Import the new Order component

function App() {
  return (
    <Routes>
      {/* Auth Route */}
      <Route path="/" element={<LoginForm />} />
      
      {/* Main Dashboard & Reservations */}
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/porch-reservations" element={<ThePorchReservations />} />
      <Route path="/food" element={<Food />} />

      {/* Table Scanner & Ordering System */}
      <Route path="/tables/qr-codes" element={<QRGenerator />} />
      <Route path="/tables/live-orders" element={<LiveOrders />} />
      <Route path="/tables/create-order" element={<Order />} /> {/* New Route */}

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default App;